import { OrderType } from '@features/sales/domain/models/order/order-split.model';
import { OrderItemDTO } from "@features/sales/domain/models/order/order-item.model";

export enum OrderStatus {
  OPEN = 'open',
  PROCESSING = 'processing',
  PENDING = 'pending',
  SETTLED = 'settled',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export interface OrderDTO {
  id: string;
  accountId: string;
  waiterId: string;
  locationId: string;
  cashDrawerId: string;
  serviceId: string;
  entries: OrderItemDTO[];
  totalAmount: number;
  status: OrderStatus;
  type?: OrderType;
}
